import { formatDistance } from 'date-fns';
import { de, enUS, es, fr, it, nl, pl, pt, ru, th, tr, zhTW } from 'date-fns/locale';
import { getRoot, types } from 'mobx-state-tree';
import { IRootStore } from 'store/root';

const _LocDate = types
    .model('LocDate', {
        serverTime: types.number, // epoch
    })
    .views((self) => {
        const views = {
            get root(): IRootStore {
                return getRoot<IRootStore>(self);
            },
            get currentDateLocal() {
                const { lang } = views.root.systemInfo;
                switch (lang) {
                    case 'en':
                        return enUS;
                    case 'de':
                        return de;
                    case 'es':
                        return es;
                    case 'fr':
                        return fr;
                    case 'it':
                        return it;
                    case 'nl':
                        return nl;
                    case 'pl':
                        return pl;
                    case 'pt':
                        return pt;
                    case 'ru':
                        return ru;
                    case 'th':
                        return th;
                    case 'tr':
                        return tr;
                    case 'zh':
                        return zhTW;
                    default:
                        return enUS;
                }
            },
            get formatDistance(): string {
                // if (!self.data) return '';
                return formatDistance(new Date((self.serverTime + views.root.systemInfo.diffServerTime) * 1000), new Date(), {
                    addSuffix: true,
                    locale: views.currentDateLocal,
                });
            },
        };
        return views;
    });

// convert epoch to Date
export const LocDateFromEpoch = types.snapshotProcessor(_LocDate, {
    preProcessor(sn: number | null) {
        return {
            serverTime: sn ?? 0,
        };
    },
});
